import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Container, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomTooltip from "utils/CustomTooltip";
import Dashboard from "../client_config/seo_config/dashboard/Dashboard";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function PPCDashboardCustomization(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const [showBoxes, setShowBoxes] = useState(false);
  const [validated, setValidatation] = useState(false);

  return (
    <Container fluid className="px-lg-5 px-0">
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center">
        <Col md={8}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">SEO Dashboard Customization</p>
          </div>
          <div>
            <p className=" f16 nunito-regular  primary ">Would you like to customize your SEO dashboards now or use the default settings?</p>
          </div>
        </Col>
        <Col md={8}>
          <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
          <div className="pb-1 pt-2">
            <CustomTooltip
              faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
              message={
                "Check the box to enable/disable, and click and drag the left handleto reorder your dashboard. Click 'Display configuration' to configure which metrics will show in each section."
              }
              inline={true}
            />{" "}
            <span className=" f16 text-info ">What does this mean?</span>
          </div>
          <div className="d-flex flex-column ">
            <Form.Check
              className="f16"
              name="ob-seo-dash-custom"
              custom
              label="I will use the default configuration"
              type="radio"
              id="ob-dash-ppc-custom-no"
              onClick={() => {
                setShowBoxes(false);
                setValidatation(true);
                props.setSeoDefault(true)
              }}
            />
            <Form.Check
              name="ob-seo-dash-custom"
              className="f16"
              custom
              label="I want to customize my dashboard layout now"
              type="radio"
              id="ob-dash-seo-custom-yes"
              onClick={() => {
                setShowBoxes(true);
                setValidatation(true);
                props.setSeoDefault(false)
              }}
            />
          </div>
        </Col>
        <Col md={11} className="mt-4">
          <p className="f14 primary">
            Check the boxes to enable/disable sections, and then click and drag dashboard boxes to reorder how they will appear in your performance
            dashboards:
          </p>
        </Col>
      </Row>

      <div className="mb-5 mask-wrapper tab-shadow">
        {showBoxes === false && <div className="mask" style={{ top: "auto" }}></div>}
        <Dashboard {...props} showBoxes={showBoxes} onboarding seoDashboard={props.seoDashboard} setSeoDashboard={props.setSeoDashboard} />
      </div>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
